import Pages from "./pages/Pages";
import Category from "./components/Category";
import WeeklyPlanner from "./components/WeeklyPlanner";
import { BrowserRouter, Link } from "react-router-dom";
import Search from "./components/Search";
import Login from "./pages/Login";
import { GiKnifeFork } from "react-icons/gi";
import "./App.css";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { DataProvider } from "./contexts/DataContext";

//import { useEffect } from "react";
//import { seedUserData } from './utils/seedFirebase';


function AppShell() {
  const { user, logout } = useAuth();

  // ADD THIS temporarily
  // Needed to see the database
  //useEffect(() => {
  //  if (user) {
  //    console.log('Attempting seed for uid:', user.uid);
  //    seedUserData(user.uid)
  //      .then(() => console.log('Seed complete'))
  //      .catch(err => console.error('Seed failed:', err));
  //  }
  //}, [user]);
  // End of temporary code


  if (!user) return <Login />;

  return (
    <DataProvider>
      <BrowserRouter>
        <nav className="nav">
          <GiKnifeFork />
          <Link to="/" className="logo">Delicious Recipes</Link>
          <div className="nav-links">
            <Link to="/user-guide" className="nav-link">📖 User Guide</Link>
            <Link to="/add-recipe" className="nav-link">👨‍🍳 Add/Edit Recipe</Link>
            <Link to="/manage-ingredients" className="nav-link">🧅 Manage Ingredients</Link>
            <button
              onClick={logout}
              className="nav-link"
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 'inherit', padding: 0,
              }}
            >
              👤 {user.email?.split('@')[0] ?? 'Account'} · Sign out
            </button>
          </div>
        </nav>
        <Search />
        <Category />
        <WeeklyPlanner />
        <Pages />
      </BrowserRouter>
    </DataProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}

export default App;
